/* YYY / Wanwan product page controller */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  function initProduct(root) {
    var dataNode = root.querySelector('[data-product-json]');
    if (!dataNode) return;

    var data = JSON.parse(dataNode.textContent);
    var state = {
      root: root,
      data: data,
      selectedOptions: []
    };
    var selected = getVariantById(data, data.selectedVariantId) || firstAvailable(data) || data.variants[0];
    state.selectedOptions = selected ? selected.options.slice() : [];

    bindOptionButtons(state);
    bindQuantity(state);
    bindGallery(state);
    bindStickyBar(state);
    bindBundle(state);
    bindMobileVariantSheet(state);
    bindContentBand(state);
    updateProduct(state, selected, false);
  }

  // Content sections render expanded (markup default) so they still read with JS off; on mobile we
  // collapse them once at load. Baymard: 'Expanded Sections' is the strongest desktop pattern,
  // 'Vertically Collapsed Sections' the strongest mobile one. Initial state only — never re-applied,
  // so a section the buyer opened stays open on resize/rotate.
  function bindContentBand(state) {
    var band = state.root.querySelector('[data-pdp-band]');
    if (!band) return;
    if (window.matchMedia('(min-width: 1024px)').matches) return;
    band.querySelectorAll('.pdp-section').forEach(function (section) {
      section.open = false;
    });
  }

  function bindOptionButtons(state) {
    state.root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-option-value]');
      if (!button || button.disabled) return;
      var position = parseInt(button.getAttribute('data-option-position'), 10) - 1;
      state.selectedOptions[position] = button.getAttribute('data-option-value');
      updateProduct(state, variantFromOptions(state.data, state.selectedOptions), true);
    });

    state.root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-sticky-variant-select]')) return;
      var variant = getVariantById(state.data, event.target.value);
      if (!variant) return;
      state.selectedOptions = variant.options.slice();
      updateProduct(state, variant, true);
    });
  }

  function bindQuantity(state) {
    state.root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quantity-change]');
      if (!button) return;
      var input = state.root.querySelector('[data-product-quantity]');
      if (!input) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + (parseInt(button.getAttribute('data-quantity-change'), 10) || 0));
      setQuantity(state, next);
    });

    state.root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-product-quantity]')) return;
      setQuantity(state, Math.max(1, parseInt(event.target.value, 10) || 1));
    });
  }

  function bindGallery(state) {
    state.root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;
      setActiveMedia(state.root, thumb.getAttribute('data-media-id'));
    });
  }

  function bindStickyBar(state) {
    var sticky = state.root.querySelector('[data-sticky-atc]');
    var anchor = state.root.querySelector('[data-cta-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var above = entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible-mobile', !entry.isIntersecting);
      sticky.classList.toggle('is-visible-desktop', !entry.isIntersecting && above);
    }, { threshold: 0 });
    observer.observe(anchor);
  }

  /* The sheet is role="dialog" aria-modal="true", which is a promise: focus moves
     in, stays in, and comes back out to whatever opened it. It made none of those
     three, so a keyboard or screen-reader user opened a modal and was left behind
     it, tabbing through the page underneath.

     Same implementation as the cart drawer in cart.js (openDrawer / closeDrawer /
     handleKeydown) — one focus-management pattern for every overlay in the theme,
     rather than a second one that drifts. */
  function bindMobileVariantSheet(state) {
    var sheet = state.root.querySelector('[data-variant-sheet]');
    if (!sheet) return;
    var panel = sheet.querySelector('.variant-sheet__panel');
    var lastFocused = null;
    var closeTimer = null;

    function isOpen() {
      return sheet.classList.contains('is-open');
    }

    function openSheet(trigger) {
      lastFocused = trigger || document.activeElement;
      if (closeTimer) window.clearTimeout(closeTimer);
      sheet.hidden = false;
      // force reflow so the transition runs from the hidden state
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Deferred one tick: focus() is ignored while the element is still
         hidden, so moving focus in the same frame as the unhide silently
         leaves it on <body>. */
      window.setTimeout(function () {
        var target = sheet.querySelector('[data-variant-sheet-option]:not([disabled])')
          || sheet.querySelector('.variant-sheet__head [data-variant-sheet-close]');
        if (target) target.focus();
        else if (panel) panel.focus();
      }, 0);
    }

    function closeSheet() {
      if (!isOpen()) return;
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
      closeTimer = window.setTimeout(function () { sheet.hidden = true; }, 180);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    state.root.addEventListener('click', function (event) {
      var open = event.target.closest('[data-variant-sheet-open]');
      var close = event.target.closest('[data-variant-sheet-close]');
      var option = event.target.closest('[data-variant-sheet-option]');

      if (open) openSheet(open);

      if (option) {
        var variant = getVariantById(state.data, option.getAttribute('data-variant-sheet-option'));
        if (variant) {
          state.selectedOptions = variant.options.slice();
          updateProduct(state, variant, true);
        }
      }

      /* After the option handler, so focus returns to the trigger only once the
         selection has been applied. */
      if (close || option) closeSheet();
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        closeSheet();
        return;
      }

      if (event.key !== 'Tab' || !panel) return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bindBundle(state) {
    var bundle = state.root.querySelector('[data-bundle-builder]');
    if (!bundle) return;

    bundle.addEventListener('change', function (event) {
      if (event.target.matches('[data-bundle-item]')) updateBundle(bundle);
    });
    bundle.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bundle-add]');
      if (!button) return;
      var items = Array.prototype.slice.call(bundle.querySelectorAll('[data-bundle-item]:checked')).map(function (input) {
        return { id: input.value, quantity: 1 };
      });
      var message = bundle.querySelector('[data-bundle-message]');
      if (message) message.textContent = '';

      var cart = window.YYYCart;
      cart.setButtonState(button, 'loading');
      cart.addItems(items, button)
        .then(function () {
          cart.setButtonState(button, 'success');
        })
        .catch(function (error) {
          cart.setButtonState(button, 'idle');
          /* Same routing rule as the single-item add: a quantity ceiling is
             about the cart, anything else is about this control. */
          if (cart.isQuantityLimitError(error)) {
            cart.notify('Maximum quantity reached', cart.describeError(error));
            cart.open(button);
          } else if (message) {
            message.textContent = cart.describeError(error) || 'Unable to add this set.';
          }
        });
    });
    updateBundle(bundle);
  }

  function updateProduct(state, variant, updateUrl) {
    if (!variant) variant = firstMatchingAvailable(state.data, state.selectedOptions) || state.data.variants[0];
    if (!variant) return;
    state.selectedOptions = variant.options.slice();

    state.root.querySelectorAll('[name="id"]').forEach(function (input) { input.value = variant.id; });
    state.root.querySelectorAll('[data-current-variant-id]').forEach(function (input) { input.value = variant.id; });
    state.root.querySelectorAll('[data-product-price]').forEach(function (el) {
      el.textContent = variant.priceHtml;
    });
    state.root.querySelectorAll('[data-product-compare]').forEach(function (el) {
      el.textContent = variant.compareAtPriceHtml || '';
      el.hidden = !variant.compareAtPriceHtml;
    });
    state.root.querySelectorAll('[data-product-save]').forEach(function (el) {
      el.textContent = variant.saveHtml ? 'Save ' + variant.saveHtml : '';
      el.hidden = !variant.saveHtml;
    });
    /* Labels come from the section so the bilingual badge Liquid renders is not
       silently replaced by an English-only one on the first variant change. */
    var labels = state.data.stockLabels || {};
    var stockText = variant.available
      ? (labels.available || 'In stock')
      : (labels.soldOut || 'Sold out');
    state.root.querySelectorAll('[data-stock-badge]').forEach(function (el) {
      el.textContent = stockText;
      el.classList.toggle('is-sold-out', !variant.available);
    });
    state.root.querySelectorAll('[data-retail-submit]').forEach(function (button) {
      button.disabled = !variant.available;
      button.querySelector('[data-submit-text]').textContent = variant.available ? 'Add to cart' : 'Sold out';
    });
    state.root.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.textContent = variant.priceHtml; });
    state.root.querySelectorAll('[data-sticky-variant-label]').forEach(function (el) { el.textContent = variant.title; });
    state.root.querySelectorAll('[data-sticky-variant-select]').forEach(function (select) { select.value = variant.id; });

    updateOptionState(state);
    if (variant.featuredMediaId) setActiveMedia(state.root, variant.featuredMediaId);
    if (updateUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function updateOptionState(state) {
    state.root.querySelectorAll('[data-option-value]').forEach(function (button) {
      var position = parseInt(button.getAttribute('data-option-position'), 10) - 1;
      var value = button.getAttribute('data-option-value');
      var candidate = state.selectedOptions.slice();
      candidate[position] = value;
      var matching = firstMatchingAvailable(state.data, candidate);
      var selected = state.selectedOptions[position] === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = !matching;
    });
  }

  function setQuantity(state, quantity) {
    state.root.querySelectorAll('[data-product-quantity], [data-sticky-quantity]').forEach(function (input) {
      input.value = quantity;
    });
  }

  function setActiveMedia(root, mediaId) {
    if (!mediaId) return;
    root.querySelectorAll('[data-product-media]').forEach(function (media) {
      media.hidden = media.getAttribute('data-media-id') !== String(mediaId);
    });
    root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      var selected = thumb.getAttribute('data-media-id') === String(mediaId);
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function updateBundle(bundle) {
    var total = 0;
    var count = 0;
    bundle.querySelectorAll('[data-bundle-item]:checked').forEach(function (input) {
      total += parseInt(input.getAttribute('data-price'), 10) || 0;
      count += 1;
    });
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var countEl = bundle.querySelector('[data-bundle-count]');
    if (totalEl) totalEl.textContent = formatMoney(total, bundle.getAttribute('data-money-format'));
    if (countEl) countEl.textContent = count + ' item' + (count === 1 ? '' : 's');
  }

  function getVariantById(data, id) {
    return data.variants.find(function (variant) { return String(variant.id) === String(id); });
  }

  function firstAvailable(data) {
    return data.variants.find(function (variant) { return variant.available; });
  }

  function variantFromOptions(data, options) {
    return data.variants.find(function (variant) {
      return variant.options.every(function (option, index) { return option === options[index]; });
    });
  }

  function firstMatchingAvailable(data, options) {
    return data.variants.find(function (variant) {
      return variant.available && options.every(function (option, index) {
        return !option || variant.options[index] === option;
      });
    });
  }

  function formatMoney(cents, format) {
    var value = Number(cents || 0) / 100;
    var money = value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toLocaleString())
      .replace(/\{\{\s*amount\s*\}\}/, money);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
